<template>
  <a-tabs v-model:activeKey="styleType" type="card">
    <a-tab-pane :key="1" tab="样式一"> </a-tab-pane>
    <a-tab-pane :key="2" tab="样式二" class="smsStyle2">
      <smsStyle2 ref="smsStyle2Ref" />
      <div style="width: 320px;" v-if="[20, 21].includes(tabType)">
        <div class="checkPicTabs mb20">
          <div
            v-for="tab in picTabs"
            :key="tab.value"
            class="checkPicTab"
            :class="{ check: checkPic === tab.value }"
            @click="checkPicChange(tab.value)"
          >
            {{ tab.label }}
          </div>
        </div>

        <!-- 图片 -->
        <div
          class="pic checkPics"
          :style="{
            background: `url(${currentPic}) center top / contain no-repeat`
          }"
        ></div>
      </div>
    </a-tab-pane>
  </a-tabs>
  <section v-show="styleType == 1">
    <a-tabs v-model:activeKey="tabType" @change="checkPic = 1">
      <a-tab-pane :key="9" tab="默认"></a-tab-pane>
      <a-tab-pane :key="10" tab="Email"></a-tab-pane>
      <a-tab-pane :key="11" tab="Phone"></a-tab-pane>
      <a-tab-pane :key="12" tab="Email+Phone"></a-tab-pane>
    </a-tabs>

    <div v-if="tabType === 9">
      <div class="df subscription" v-if="!popupParams.peopleSupport">
        <div class="">
          <div class="w500 mb20">
            <div>
              <div class="mb4">一键注册勾选状态：</div>
              <div class="w500 mb20">
                <a-radio-group
                  :disabled="notDefaultLang"
                  :options="[
                    { value: null, label: '不启用' },
                    { value: '0', label: '默认不勾选' },
                    { value: '1', label: '默认勾选' }
                  ]"
                  v-model:value="popupSet9.quickRegisterCheckStatus"
                  @change="
                    val => changeQuickRegisterCheckStatus(popupSet9, val)
                  "
                />
              </div>
              <div class="mb4">一键注册引导文案：</div>
              <quillEditor
                v-if="queryParams?.terminalId === '1'"
                v-model:value="
                  popupSet9.langs.find(v => v.langCode == langCode)
                    .quickRegisterText
                "
                style="height: 100px; width: 500px;"
                :options="editorOption"
                class="mb20"
              />
              <a-textarea
                v-else
                v-model:value="
                  popupSet9.langs.find(v => v.langCode == langCode)
                    .quickRegisterText
                "
                class="mb20"
              />
            </div>
            <div style="height: 20px;"></div>
          </div>
          <div class="w500 mb20">
            <a-radio-group
              :disabled="notDefaultLang"
              :options="[
                { value: 1, label: 'SMS' },
                {
                  value: 2,
                  label: 'SMS+WA',
                  disabled: queryParams?.terminalId === '2'
                }
              ]"
              v-model:value="popupSet9.subscriptionChannel"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4"><span class="red">*</span>关联活动：</div>
            <a-radio-group
              :disabled="notDefaultLang"
              v-model:value="popupSet9.associatedActivity"
              @change="popupSet9.activityData = ''"
            >
              <a-radio style="display: flex;" :style="radioStyle" :value="1"
                >无</a-radio
              >
              <a-radio
                style="display: flex;"
                :style="radioStyle"
                :value="2"
                :disabled="queryParams?.terminalId === '2'"
              >
                盲盒抽奖
                <a-input
                  v-if="popupSet9.associatedActivity == 2"
                  placeholder="请输入活动ID"
                  :disabled="
                    popupSet9.associatedActivity != 2 || notDefaultLang
                  "
                  style="width: 300px; margin-left: 10px"
                  v-model:value="popupSet9.activityData"
                />
              </a-radio>
              <a-radio
                style="display: flex;"
                :style="radioStyle"
                :value="3"
                :disabled="queryParams?.terminalId === '2'"
              >
                卡牌抽奖
                <a-input
                  v-if="popupSet9.associatedActivity == 3"
                  placeholder="请输入活动ID"
                  :disabled="
                    popupSet9.associatedActivity != 3 || notDefaultLang
                  "
                  style="width: 300px; margin-left: 10px"
                  v-model:value="popupSet9.activityData"
                />
              </a-radio>
              <a-radio
                style="display: flex;"
                :style="radioStyle"
                :value="4"
                :disabled="queryParams?.terminalId === '2'"
              >
                转盘抽奖预热抽
                <a-input
                  v-if="popupSet9.associatedActivity == 4"
                  placeholder="请输入活动ID"
                  :disabled="
                    popupSet9.associatedActivity != 4 || notDefaultLang
                  "
                  style="width: 300px; margin-left: 10px"
                  v-model:value="popupSet9.activityData"
                />
              </a-radio>
              <a-radio
                style="display: flex;"
                :style="radioStyle"
                :value="5"
                :disabled="queryParams?.terminalId === '2'"
              >
                转盘抽奖立即抽
                <a-input
                  v-if="popupSet9.associatedActivity == 5"
                  placeholder="请输入活动ID"
                  :disabled="
                    popupSet9.associatedActivity != 5 || notDefaultLang
                  "
                  style="width: 300px; margin-left: 10px"
                  v-model:value="popupSet9.activityData"
                />
              </a-radio>
            </a-radio-group>
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              {{
                queryParams?.terminalId === '1'
                  ? 'Email输入框文案-PC&M:'
                  : 'Email输入框文案-App:'
              }}
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet9.langs.find(v => v.langCode == langCode).phEmailText
              "
              :maxlength="100"
              placeholder="请输入"
            />
          </div>

          <div class="w500 mb20">
            <div class="mb4">
              {{
                queryParams?.terminalId === '1'
                  ? 'Phone输入框文案-PC&M:'
                  : 'Phone输入框文案-App:'
              }}
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet9.langs.find(v => v.langCode == langCode).phPhoneText
              "
              :maxlength="100"
              placeholder="请输入"
            />
          </div>

          <div class="w500 mb20" v-if="queryParams?.terminalId === '1'">
            <div class="mb4"><span class="red">*</span>订阅文案-PC：</div>
            <quillEditor
              v-model:value="
                popupSet9.langs.find(v => v.langCode == langCode).pcText
              "
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
          </div>

          <div class="w500 mb20">
            <div class="mb4">
              <span class="red">*</span
              >{{
                queryParams?.terminalId === '1'
                  ? '订阅文案-M：'
                  : '订阅文案-App：'
              }}
            </div>
            <quillEditor
              v-if="queryParams?.terminalId === '1'"
              v-model:value="
                popupSet9.langs.find(v => v.langCode == langCode).mText
              "
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
            <a-textarea
              v-else
              v-model:value="
                popupSet9.langs.find(v => v.langCode == langCode).mText
              "
            />
          </div>

          <div class="w500 mb20" v-if="queryParams?.terminalId === '2'">
            <div class="mb4">订阅副标题文案-App：</div>
            <a-textarea
              :maxlength="200"
              v-model:value="
                popupSet9.langs.find(v => v.langCode == langCode).mfText
              "
            />
          </div>

          <div class="w500 mb20" v-if="queryParams?.terminalId === '1'">
            <div class="mb4"><span class="red">*</span>勾选框文案-PC：</div>
            <quillEditor
              v-model:value="
                popupSet9.langs.find(v => v.langCode == langCode).checkboxPcText
              "
              style="height: 100px; width: 500px;"
              :options="PrivacyOptions"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              <span class="red">*</span
              >{{
                queryParams?.terminalId === '1'
                  ? '勾选框文案-M：'
                  : '勾选框文案-App：'
              }}
            </div>
            <quillEditor
              v-if="queryParams?.terminalId === '1'"
              v-model:value="
                popupSet9.langs.find(v => v.langCode == langCode).checkboxMText
              "
              style="height: 100px; width: 500px;"
              :options="PrivacyOptions"
            />
            <a-input
              v-else
              v-model:value="
                popupSet9.langs.find(v => v.langCode == langCode).checkboxMText
              "
            />
          </div>

          <div class="w500 mb20">
            <div class="mb4"><span class="red">*</span>勾选框：</div>
            <a-radio-group
              :disabled="true"
              :options="[
                { value: 1, label: '默认勾选' },
                { value: 0, label: '默认不勾选' }
              ]"
              v-model:value="
                popupSet9.langs.find(v => v.langCode == langCode)
                  .checkboxDefaultChoose
              "
            />
          </div>

          <div class="w500 mb20">
            <div class="mb4"><span class="red">*</span>订阅按钮：</div>
            <a-input
              class="w300"
              v-model:value="
                popupSet9.langs.find(v => v.langCode == langCode).buttonText
              "
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4"><span class="red"></span>图片：</div>
            <div class="df">
              <div class="mr20" v-if="queryParams?.terminalId === '1'">
                <div class="w120 h120 mb10 pr">
                  <a-upload-dragger
                    :fileList="[]"
                    :show-upload-list="false"
                    name="file"
                    :multiple="true"
                    :customRequest="e => upload(e, 9, '9pc')"
                    :accept="'.png,.jpg,.jpeg,.gif'"
                    :headers="uploadHeaders"
                  >
                    <div
                      v-if="
                        ['', null, undefined].includes(
                          popupSet9.langs.find(v => v.langCode == langCode)
                            .pcImgUrl
                        )
                      "
                    >
                      <div
                        class="w120 h120 tac"
                        style="color: #666666; font-size: 40px; line-height: 120px;"
                      >
                        <PictureOutlined />
                      </div>
                    </div>
                  </a-upload-dragger>
                  <div
                    v-if="
                      !['', null, undefined].includes(
                        popupSet9.langs.find(v => v.langCode == langCode)
                          .pcImgUrl
                      )
                    "
                    class="h120 pa l0 t0 sidebarContentBg"
                    :style="
                      `width: 120px; background: url('${
                        popupSet9?.langs?.find(v => v.langCode == langCode)
                          ?.pcImgUrl
                      }') center center/ cover no-repeat;`
                    "
                  >
                    <div class="hover">
                      <EyeOutlined
                        @click="
                          () =>
                            changeVisiblePic(
                              true,
                              popupSet9.langs.find(v => v.langCode == langCode)
                                .pcImgUrl
                            )
                        "
                      />
                      &nbsp;&nbsp;
                      <DeleteOutlined
                        @click="
                          popupSet9.langs.find(
                            v => v.langCode == langCode
                          ).pcImgUrl = null
                        "
                      />
                    </div>
                  </div>
                </div>
                <div class="tac">PC图片比例 420*560</div>
                <MaterialSelectionListModal
                  style="margin: 10px"
                  @submit="val => handleSubmit(val, 9, '9pc')"
                  :validateImageOrVideoArea="['420*560']"
                  :validateImageOrVideoFormatAndSizeByMB="{
                    jpg: 100,
                    png: 100,
                    gif: 100,
                    jpeg: 100,
                    'image/jpeg': 100,
                    'image/png': 100,
                    'image/gif': 100,
                    'image/jpg': 100
                  }"
                  :fileterResourceType="1"
                  :siteId="Number(queryParams?.siteId)"
                  :terminalId="Number(queryParams?.terminalId)"
                  :subTerminalId="Number(queryParams?.terminalId)"
                />
              </div>
              <div>
                <div>
                  <div class="w120 h120 mb10 pr">
                    <a-upload-dragger
                      :fileList="[]"
                      :show-upload-list="false"
                      name="file"
                      :multiple="true"
                      :customRequest="e => upload(e, 9, '9m')"
                      :accept="'.png,.jpg,.jpeg,.gif'"
                      :headers="uploadHeaders"
                    >
                      <div
                        v-if="
                          ['', null, undefined].includes(
                            popupSet9.langs.find(v => v.langCode == langCode)
                              .mImgUrl
                          )
                        "
                      >
                        <div
                          class="w120 h120 tac"
                          style="color: #666666; font-size: 40px; line-height: 120px;"
                        >
                          <PictureOutlined />
                        </div>
                      </div>
                    </a-upload-dragger>
                    <div
                      v-if="
                        !['', null, undefined].includes(
                          popupSet9.langs.find(v => v.langCode == langCode)
                            .mImgUrl
                        )
                      "
                      class="h120 pa l0 t0 sidebarContentBg"
                      :style="
                        `width: 120px; background: url('${
                          popupSet9?.langs?.find(v => v.langCode == langCode)
                            ?.mImgUrl
                        }') center center/ cover no-repeat;`
                      "
                    >
                      <div class="hover">
                        <EyeOutlined
                          @click="
                            () =>
                              changeVisiblePic(
                                true,
                                popupSet9.langs.find(
                                  v => v.langCode == langCode
                                ).mImgUrl
                              )
                          "
                        />
                        &nbsp;&nbsp;
                        <DeleteOutlined
                          @click="
                            popupSet9.langs.find(
                              v => v.langCode == langCode
                            ).mImgUrl = null
                          "
                        />
                      </div>
                    </div>
                  </div>
                  <div class="tac">
                    {{
                      queryParams?.terminalId === '1'
                        ? 'M图片比例 311*160'
                        : 'App图片比例 311*160'
                    }}
                  </div>
                  <MaterialSelectionListModal
                    style="margin: 10px"
                    @submit="val => handleSubmit(val, 9, '9m')"
                    :validateImageOrVideoArea="['311*160']"
                    :validateImageOrVideoFormatAndSizeByMB="{
                      jpg: 100,
                      png: 100,
                      gif: 100,
                      jpeg: 100,
                      'image/jpeg': 100,
                      'image/png': 100,
                      'image/gif': 100,
                      'image/jpg': 100
                    }"
                    :fileterResourceType="1"
                    :siteId="Number(queryParams?.siteId)"
                    :terminalId="Number(queryParams?.terminalId)"
                    :subTerminalId="queryParams?.terminalId === '1' ? 2 : 0"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="w500 mb20">
            <div class="mb4"><span class="red"></span>Email悬浮图：</div>
            <div class="df">
              <div>
                <div>
                  <div class="w120 h120 mb10 pr">
                    <a-upload-dragger
                      :fileList="[]"
                      :show-upload-list="false"
                      name="file"
                      :multiple="true"
                      :customRequest="e => upload(e, 9, '9emailSuspendM')"
                      :accept="'.png,.jpg,.jpeg,.gif'"
                      :headers="uploadHeaders"
                    >
                      <div
                        v-if="
                          ['', null, undefined].includes(
                            popupSet9.langs.find(v => v.langCode == langCode)
                              .mEmailSuspendImgUrl
                          )
                        "
                      >
                        <div
                          class="w120 h120 tac"
                          style="color: #666666; font-size: 40px; line-height: 120px;"
                        >
                          <PictureOutlined />
                        </div>
                      </div>
                    </a-upload-dragger>
                    <div
                      v-if="
                        !['', null, undefined].includes(
                          popupSet9.langs.find(v => v.langCode == langCode)
                            .mEmailSuspendImgUrl
                        )
                      "
                      class="h120 pa l0 t0 sidebarContentBg"
                      :style="
                        `width: 120px; background: url('${
                          popupSet9?.langs?.find(v => v.langCode == langCode)
                            ?.mEmailSuspendImgUrl
                        }') center center/ cover no-repeat;`
                      "
                    >
                      <div class="hover">
                        <EyeOutlined
                          @click="
                            () =>
                              changeVisiblePic(
                                true,
                                popupSet9.langs.find(
                                  v => v.langCode == langCode
                                ).mEmailSuspendImgUrl
                              )
                          "
                        />
                        &nbsp;&nbsp;
                        <DeleteOutlined
                          @click="
                            popupSet9.langs.find(
                              v => v.langCode == langCode
                            ).mEmailSuspendImgUrl = null
                          "
                        />
                      </div>
                    </div>
                  </div>
                  <div class="tac">
                    {{
                      queryParams?.terminalId === '1'
                        ? 'M图片比例 130*80'
                        : 'App图片比例 130*80'
                    }}
                  </div>
                  <MaterialSelectionListModal
                    style="margin: 10px"
                    @submit="val => handleSubmit(val, 9, '9emailSuspendM')"
                    :validateImageOrVideoArea="['130*80']"
                    :validateImageOrVideoFormatAndSizeByMB="{
                      jpg: 100,
                      png: 100,
                      gif: 100,
                      jpeg: 100,
                      'image/jpeg': 100,
                      'image/png': 100,
                      'image/gif': 100,
                      'image/jpg': 100
                    }"
                    :fileterResourceType="1"
                    :siteId="Number(queryParams?.siteId)"
                    :terminalId="Number(queryParams?.terminalId)"
                    :subTerminalId="queryParams?.terminalId === '1' ? 2 : 0"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="w500 mb20">
            <div class="mb4"><span class="red"></span>SMS悬浮图：</div>
            <div class="df">
              <div>
                <div>
                  <div class="w120 h120 mb10 pr">
                    <a-upload-dragger
                      :fileList="[]"
                      :show-upload-list="false"
                      name="file"
                      :multiple="true"
                      :customRequest="e => upload(e, 9, '9smsSuspendM')"
                      :accept="'.png,.jpg,.jpeg,.gif'"
                      :headers="uploadHeaders"
                    >
                      <div
                        v-if="
                          ['', null, undefined].includes(
                            popupSet9.langs.find(v => v.langCode == langCode)
                              .mSmsSuspendImgUrl
                          )
                        "
                      >
                        <div
                          class="w120 h120 tac"
                          style="color: #666666; font-size: 40px; line-height: 120px;"
                        >
                          <PictureOutlined />
                        </div>
                      </div>
                    </a-upload-dragger>
                    <div
                      v-if="
                        !['', null, undefined].includes(
                          popupSet9.langs.find(v => v.langCode == langCode)
                            .mSmsSuspendImgUrl
                        )
                      "
                      class="h120 pa l0 t0 sidebarContentBg"
                      :style="
                        `width: 120px; background: url('${
                          popupSet9?.langs?.find(v => v.langCode == langCode)
                            ?.mSmsSuspendImgUrl
                        }') center center/ cover no-repeat;`
                      "
                    >
                      <div class="hover">
                        <EyeOutlined
                          @click="
                            () =>
                              changeVisiblePic(
                                true,
                                popupSet9.langs.find(
                                  v => v.langCode == langCode
                                ).mSmsSuspendImgUrl
                              )
                          "
                        />
                        &nbsp;&nbsp;
                        <DeleteOutlined
                          @click="
                            popupSet9.langs.find(
                              v => v.langCode == langCode
                            ).mSmsSuspendImgUrl = null
                          "
                        />
                      </div>
                    </div>
                  </div>
                  <div class="tac">
                    {{
                      queryParams?.terminalId === '1'
                        ? 'M图片比例 130*80'
                        : 'App图片比例 130*80'
                    }}
                  </div>
                  <MaterialSelectionListModal
                    style="margin: 10px"
                    @submit="val => handleSubmit(val, 9, '9smsSuspendM')"
                    :validateImageOrVideoArea="['130*80']"
                    :validateImageOrVideoFormatAndSizeByMB="{
                      jpg: 100,
                      png: 100,
                      gif: 100,
                      jpeg: 100,
                      'image/jpeg': 100,
                      'image/png': 100,
                      'image/gif': 100,
                      'image/jpg': 100
                    }"
                    :fileterResourceType="1"
                    :siteId="Number(queryParams?.siteId)"
                    :terminalId="Number(queryParams?.terminalId)"
                    :subTerminalId="queryParams?.terminalId === '1' ? 2 : 0"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="EditContainerRight" v-if="queryParams?.terminalId === '1'">
          <div class="checkPicTabs mb20">
            <div
              :class="`checkPicTab ${checkPic === 1 ? 'check' : ''}`"
              @click="() => checkPicChange(1)"
            >
              PC端
            </div>
            <div
              :class="`checkPicTab ${checkPic === 2 ? 'check' : ''}`"
              @click="() => checkPicChange(2)"
            >
              M端
            </div>
          </div>
          <div
            class="pic checkPics"
            :style="
              `background: url(${
                checkPic === 1 ? pc1 : m1
              }) center top/contain no-repeat;`
            "
          ></div>
        </div>
        <div class="EditContainerRight" v-else>
          <div class="checkPicTabs mb20">
            <div :class="`checkPicTab check`" @click="() => checkPicChange(2)">
              App端
            </div>
          </div>
          <div
            class="pic checkPics"
            :style="`background: url(${m1}) center top/contain no-repeat;`"
          ></div>
        </div>
      </div>

      <div
        class="df subscription"
        v-if="popupParams.peopleSupport === 1 && popupParams.peopleType === 1"
      >
        <div class="">
          <div>
            <div class="mb4">一键注册勾选状态：</div>
            <div class="w500 mb20">
              <a-radio-group
                :disabled="notDefaultLang"
                :options="[
                  { value: null, label: '不启用' },
                  { value: '0', label: '默认不勾选' },
                  {
                    value: '1',
                    label: '默认勾选'
                  }
                ]"
                v-model:value="popupSet13.quickRegisterCheckStatus"
                @change="val => changeQuickRegisterCheckStatus(popupSet9, val)"
              />
            </div>
            <div class="mb4">一键注册引导文案：</div>
            <quillEditor
              v-if="queryParams?.terminalId === '1'"
              v-model:value="
                popupSet13.langs.find(v => v.langCode == langCode)
                  .quickRegisterText
              "
              style="height: 100px; width: 500px;"
              :options="editorOption"
              class="mb20"
            />
            <a-textarea
              v-else
              v-model:value="
                popupSet13.langs.find(v => v.langCode == langCode)
                  .quickRegisterText
              "
              class="mb20"
            />
          </div>
          <div style="height: 20px;"></div>
          <div class="w500 mb20">
            <a-radio-group
              :disabled="notDefaultLang"
              :options="[
                { value: 1, label: 'SMS' },
                { value: 2, label: 'SMS+WA' }
              ]"
              v-model:value="popupSet13.subscriptionChannel"
            />
          </div>

          <div class="w500 mb20">
            <div class="mb4"><span class="red">*</span>关联活动：</div>
            <a-radio-group
              :disabled="notDefaultLang"
              v-model:value="popupSet13.associatedActivity"
              @change="popupSet13.activityData = ''"
            >
              <a-radio style="display: flex;" :style="radioStyle" :value="1"
                >无</a-radio
              >
              <a-radio style="display: flex;" :style="radioStyle" :value="2">
                盲盒抽奖
                <a-input
                  v-if="popupSet13.associatedActivity == 2"
                  placeholder="请输入活动ID"
                  :disabled="
                    popupSet13.associatedActivity != 2 || notDefaultLang
                  "
                  style="width: 300px; margin-left: 10px"
                  v-model:value="popupSet13.activityData"
                />
              </a-radio>
              <a-radio style="display: flex;" :style="radioStyle" :value="3">
                卡牌抽奖
                <a-input
                  v-if="popupSet13.associatedActivity == 3"
                  placeholder="请输入活动ID"
                  :disabled="
                    popupSet13.associatedActivity != 3 || notDefaultLang
                  "
                  style="width: 300px; margin-left: 10px"
                  v-model:value="popupSet13.activityData"
                />
              </a-radio>
              <a-radio style="display: flex;" :style="radioStyle" :value="4">
                转盘抽奖预热抽
                <a-input
                  v-if="popupSet13.associatedActivity == 4"
                  placeholder="请输入活动ID"
                  :disabled="
                    popupSet13.associatedActivity != 4 || notDefaultLang
                  "
                  style="width: 300px; margin-left: 10px"
                  v-model:value="popupSet13.activityData"
                />
              </a-radio>
              <a-radio style="display: flex;" :style="radioStyle" :value="5">
                转盘抽奖立即抽
                <a-input
                  v-if="popupSet13.associatedActivity == 5"
                  placeholder="请输入活动ID"
                  :disabled="
                    popupSet13.associatedActivity != 5 || notDefaultLang
                  "
                  style="width: 300px; margin-left: 10px"
                  v-model:value="popupSet13.activityData"
                />
              </a-radio>
            </a-radio-group>
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              {{
                queryParams?.terminalId === '1'
                  ? 'Email输入框文案-PC&M:'
                  : 'Email输入框文案-App:'
              }}
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet13.langs.find(v => v.langCode == langCode).phEmailText
              "
              :maxlength="100"
              placeholder="请输入"
            />
          </div>

          <div class="w500 mb20">
            <div class="mb4">
              {{
                queryParams?.terminalId === '1'
                  ? 'Phone输入框文案-PC&M:'
                  : 'Phone输入框文案-App:'
              }}
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet13.langs.find(v => v.langCode == langCode).phPhoneText
              "
              :maxlength="100"
              placeholder="请输入"
            />
          </div>

          <div class="w500 mb20" v-if="queryParams?.terminalId === '1'">
            <div class="mb4"><span class="red">*</span>订阅文案-PC：</div>
            <quillEditor
              v-model:value="
                popupSet13.langs.find(v => v.langCode == langCode).pcText
              "
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
          </div>

          <div class="w500 mb20">
            <div class="mb4"><span class="red">*</span>订阅文案-M：</div>
            <quillEditor
              v-if="queryParams?.terminalId === '1'"
              v-model:value="
                popupSet13.langs.find(v => v.langCode == langCode).mText
              "
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
            <a-input
              v-else
              v-model:value="
                popupSet13.langs.find(v => v.langCode == langCode).mText
              "
            />
          </div>

          <div class="w500 mb20" v-if="queryParams?.terminalId === '1'">
            <div class="mb4"><span class="red">*</span>勾选框文案-PC：</div>
            <quillEditor
              v-model:value="
                popupSet13.langs.find(v => v.langCode == langCode)
                  .checkboxPcText
              "
              style="height: 100px; width: 500px;"
              :options="PrivacyOptions"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4"><span class="red">*</span>勾选框文案-M：</div>
            <quillEditor
              v-if="queryParams?.terminalId === '1'"
              v-model:value="
                popupSet13.langs.find(v => v.langCode == langCode).checkboxMText
              "
              style="height: 100px; width: 500px;"
              :options="PrivacyOptions"
            />
            <a-input
              v-else
              v-model:value="
                popupSet13.langs.find(v => v.langCode == langCode).checkboxMText
              "
            />
          </div>

          <div class="w500 mb20">
            <div class="mb4"><span class="red">*</span>勾选框：</div>
            <a-radio-group
              :disabled="true"
              :options="[
                { value: 1, label: '默认勾选' },
                { value: 0, label: '默认不勾选' }
              ]"
              v-model:value="
                popupSet13.langs.find(v => v.langCode == langCode)
                  .checkboxDefaultChoose
              "
            />
          </div>

          <div class="w500 mb20">
            <div class="mb4"><span class="red">*</span>订阅按钮：</div>
            <a-input
              class="w300"
              v-model:value="
                popupSet13.langs.find(v => v.langCode == langCode).buttonText
              "
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4"><span class="red"></span>图片：</div>
            <div class="df">
              <div class="mr20">
                <div class="w120 h120 mb10 pr">
                  <a-upload-dragger
                    :fileList="[]"
                    :show-upload-list="false"
                    name="file"
                    :multiple="true"
                    :customRequest="e => upload(e, 13, '9pc')"
                    :accept="'.png,.jpg,.jpeg,.gif'"
                    :headers="uploadHeaders"
                  >
                    <div
                      v-if="
                        ['', null, undefined].includes(
                          popupSet13.langs.find(v => v.langCode == langCode)
                            .pcImgUrl
                        )
                      "
                    >
                      <div
                        class="w120 h120 tac"
                        style="color: #666666; font-size: 40px; line-height: 120px;"
                      >
                        <PictureOutlined />
                      </div>
                    </div>
                  </a-upload-dragger>
                  <div
                    v-if="
                      !['', null, undefined].includes(
                        popupSet13.langs.find(v => v.langCode == langCode)
                          .pcImgUrl
                      )
                    "
                    class="h120 pa l0 t0 sidebarContentBg"
                    :style="
                      `width: 120px; background: url('${
                        popupSet13?.langs?.find(v => v.langCode == langCode)
                          ?.pcImgUrl
                      }') center center/ cover no-repeat;`
                    "
                  >
                    <div class="hover">
                      <EyeOutlined
                        @click="
                          () =>
                            changeVisiblePic(
                              true,
                              popupSet13.langs.find(v => v.langCode == langCode)
                                .pcImgUrl
                            )
                        "
                      />
                      &nbsp;&nbsp;
                      <DeleteOutlined
                        @click="
                          popupSet13.langs.find(
                            v => v.langCode == langCode
                          ).pcImgUrl = null
                        "
                      />
                    </div>
                  </div>
                </div>
                <div class="tac">PC图片比例 420*560</div>
                <MaterialSelectionListModal
                  style="margin: 10px"
                  @submit="val => handleSubmit(val, 13, '9pc')"
                  :validateImageOrVideoArea="['420*560']"
                  :validateImageOrVideoFormatAndSizeByMB="{
                    jpg: 100,
                    png: 100,
                    gif: 100,
                    jpeg: 100,
                    'image/jpeg': 100,
                    'image/png': 100,
                    'image/gif': 100,
                    'image/jpg': 100
                  }"
                  :fileterResourceType="1"
                  :siteId="Number(queryParams?.siteId)"
                  :terminalId="Number(queryParams?.terminalId)"
                  :subTerminalId="Number(queryParams?.terminalId)"
                />
              </div>
              <div>
                <div class="w120 h120 mb10 pr">
                  <a-upload-dragger
                    :fileList="[]"
                    :show-upload-list="false"
                    name="file"
                    :multiple="true"
                    :customRequest="e => upload(e, 13, '9m')"
                    :accept="'.png,.jpg,.jpeg,.gif'"
                    :headers="uploadHeaders"
                  >
                    <div
                      v-if="
                        ['', null, undefined].includes(
                          popupSet13.langs.find(v => v.langCode == langCode)
                            .mImgUrl
                        )
                      "
                    >
                      <div
                        class="w120 h120 tac"
                        style="color: #666666; font-size: 40px; line-height: 120px;"
                      >
                        <PictureOutlined />
                      </div>
                    </div>
                  </a-upload-dragger>
                  <div
                    v-if="
                      !['', null, undefined].includes(
                        popupSet13.langs.find(v => v.langCode == langCode)
                          .mImgUrl
                      )
                    "
                    class="h120 pa l0 t0 sidebarContentBg"
                    :style="
                      `width: 120px; background: url('${
                        popupSet13?.langs?.find(v => v.langCode == langCode)
                          ?.mImgUrl
                      }') center center/ cover no-repeat;`
                    "
                  >
                    <div class="hover">
                      <EyeOutlined
                        @click="
                          () =>
                            changeVisiblePic(
                              true,
                              popupSet13.langs.find(v => v.langCode == langCode)
                                .mImgUrl
                            )
                        "
                      />
                      &nbsp;&nbsp;
                      <DeleteOutlined
                        @click="
                          popupSet13.langs.find(
                            v => v.langCode == langCode
                          ).mImgUrl = null
                        "
                      />
                    </div>
                  </div>
                </div>
                <div class="tac">M图片比例 311*160</div>
                <MaterialSelectionListModal
                  style="margin: 10px"
                  @submit="val => handleSubmit(val, 13, '9m')"
                  :validateImageOrVideoArea="['311*160']"
                  :validateImageOrVideoFormatAndSizeByMB="{
                    jpg: 100,
                    png: 100,
                    gif: 100,
                    jpeg: 100,
                    'image/jpeg': 100,
                    'image/png': 100,
                    'image/gif': 100,
                    'image/jpg': 100
                  }"
                  :fileterResourceType="1"
                  :siteId="Number(queryParams?.siteId)"
                  :terminalId="Number(queryParams?.terminalId)"
                  :subTerminalId="2"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="EditContainerRight">
          <div class="checkPicTabs mb20">
            <div
              :class="`checkPicTab ${checkPic === 1 ? 'check' : ''}`"
              @click="() => checkPicChange(1)"
            >
              PC端
            </div>
            <div
              :class="`checkPicTab ${checkPic === 2 ? 'check' : ''}`"
              @click="() => checkPicChange(2)"
            >
              M端
            </div>
          </div>
          <div
            class="pic checkPics"
            :style="
              `background: url(${
                checkPic === 1 ? pc1 : m1
              }) center top/contain no-repeat;`
            "
          ></div>
        </div>
      </div>

      <div
        class="df subscription"
        v-if="popupParams.peopleSupport === 1 && popupParams.peopleType === 0"
      >
        <div class="">
          <div>
            <div class="mb4">一键注册勾选状态：</div>
            <div class="w500 mb20">
              <a-radio-group
                :disabled="notDefaultLang"
                :options="[
                  { value: null, label: '不启用' },
                  { value: '0', label: '默认不勾选' },
                  {
                    value: '1',
                    label: '默认勾选'
                  }
                ]"
                v-model:value="popupSet17.quickRegisterCheckStatus"
                @change="val => changeQuickRegisterCheckStatus(popupSet9, val)"
              />
            </div>
            <div class="mb4">一键注册引导文案：</div>
            <quillEditor
              v-if="queryParams?.terminalId === '1'"
              v-model:value="
                popupSet17.langs.find(v => v.langCode == langCode)
                  .quickRegisterText
              "
              style="height: 100px; width: 500px;"
              :options="editorOption"
              class="mb20"
            />
            <a-textarea
              v-else
              v-model:value="
                popupSet17.langs.find(v => v.langCode == langCode)
                  .quickRegisterText
              "
              class="mb20"
            />
          </div>
          <div style="height: 20px;"></div>
          <div class="w500 mb20">
            <a-radio-group
              :disabled="notDefaultLang"
              :options="[
                { value: 1, label: 'SMS' },
                { value: 2, label: 'SMS+WA' }
              ]"
              v-model:value="popupSet17.subscriptionChannel"
            />
          </div>

          <div class="w500 mb20">
            <div class="mb4"><span class="red">*</span>关联活动：</div>
            <a-radio-group
              :disabled="notDefaultLang"
              v-model:value="popupSet17.associatedActivity"
              @change="popupSet17.activityData = ''"
            >
              <a-radio style="display: flex;" :style="radioStyle" :value="1"
                >无</a-radio
              >
              <a-radio style="display: flex;" :style="radioStyle" :value="2">
                盲盒抽奖
                <a-input
                  v-if="popupSet17.associatedActivity == 2"
                  placeholder="请输入活动ID"
                  :disabled="
                    popupSet17.associatedActivity != 2 || notDefaultLang
                  "
                  style="width: 300px; margin-left: 10px"
                  v-model:value="popupSet17.activityData"
                />
              </a-radio>
              <a-radio style="display: flex;" :style="radioStyle" :value="3">
                卡牌抽奖
                <a-input
                  v-if="popupSet17.associatedActivity == 3"
                  placeholder="请输入活动ID"
                  :disabled="
                    popupSet17.associatedActivity != 3 || notDefaultLang
                  "
                  style="width: 300px; margin-left: 10px"
                  v-model:value="popupSet17.activityData"
                />
              </a-radio>
              <a-radio style="display: flex;" :style="radioStyle" :value="4">
                转盘抽奖预热抽
                <a-input
                  v-if="popupSet17.associatedActivity == 4"
                  placeholder="请输入活动ID"
                  :disabled="
                    popupSet17.associatedActivity != 4 || notDefaultLang
                  "
                  style="width: 300px; margin-left: 10px"
                  v-model:value="popupSet17.activityData"
                />
              </a-radio>
              <a-radio style="display: flex;" :style="radioStyle" :value="5">
                转盘抽奖立即抽
                <a-input
                  v-if="popupSet17.associatedActivity == 5"
                  placeholder="请输入活动ID"
                  :disabled="
                    popupSet17.associatedActivity != 5 || notDefaultLang
                  "
                  style="width: 300px; margin-left: 10px"
                  v-model:value="popupSet17.activityData"
                />
              </a-radio>
            </a-radio-group>
          </div>

          <div class="w500 mb20">
            <div class="mb4">
              {{
                queryParams?.terminalId === '1'
                  ? 'Email输入框文案-PC&M:'
                  : 'Email输入框文案-App:'
              }}
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet17.langs.find(v => v.langCode == langCode).phEmailText
              "
              :maxlength="100"
              placeholder="请输入"
            />
          </div>

          <div class="w500 mb20">
            <div class="mb4">
              {{
                queryParams?.terminalId === '1'
                  ? 'Phone输入框文案-PC&M:'
                  : 'Phone输入框文案-App:'
              }}
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet17.langs.find(v => v.langCode == langCode).phPhoneText
              "
              :maxlength="100"
              placeholder="请输入"
            />
          </div>

          <div class="w500 mb20" v-if="queryParams?.terminalId === '1'">
            <div class="mb4"><span class="red">*</span>订阅文案-PC：</div>
            <quillEditor
              v-model:value="
                popupSet17.langs.find(v => v.langCode == langCode).pcText
              "
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
          </div>

          <div class="w500 mb20">
            <div class="mb4"><span class="red">*</span>订阅文案-M：</div>
            <quillEditor
              v-if="queryParams?.terminalId === '1'"
              v-model:value="
                popupSet17.langs.find(v => v.langCode == langCode).mText
              "
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
            <a-input
              v-else
              v-model:value="
                popupSet17.langs.find(v => v.langCode == langCode).mText
              "
            />
          </div>

          <div class="w500 mb20" v-if="queryParams?.terminalId === '1'">
            <div class="mb4"><span class="red">*</span>勾选框文案-PC：</div>
            <quillEditor
              v-model:value="
                popupSet17.langs.find(v => v.langCode == langCode)
                  .checkboxPcText
              "
              style="height: 100px; width: 500px;"
              :options="PrivacyOptions"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4"><span class="red">*</span>勾选框文案-M：</div>
            <quillEditor
              v-if="queryParams?.terminalId === '1'"
              v-model:value="
                popupSet17.langs.find(v => v.langCode == langCode).checkboxMText
              "
              style="height: 100px; width: 500px;"
              :options="PrivacyOptions"
            />
            <a-input
              v-else
              v-model:value="
                popupSet17.langs.find(v => v.langCode == langCode).checkboxMText
              "
            />
          </div>

          <div class="w500 mb20">
            <div class="mb4"><span class="red">*</span>勾选框：</div>
            <a-radio-group
              :disabled="true"
              :options="[
                { value: 1, label: '默认勾选' },
                { value: 0, label: '默认不勾选' }
              ]"
              v-model:value="
                popupSet17.langs.find(v => v.langCode == langCode)
                  .checkboxDefaultChoose
              "
            />
          </div>

          <div class="w500 mb20">
            <div class="mb4"><span class="red">*</span>订阅按钮：</div>
            <a-input
              class="w300"
              v-model:value="
                popupSet17.langs.find(v => v.langCode == langCode).buttonText
              "
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4"><span class="red"></span>图片：</div>
            <div class="df">
              <div class="mr20">
                <div class="w120 h120 mb10 pr">
                  <a-upload-dragger
                    :fileList="[]"
                    :show-upload-list="false"
                    name="file"
                    :multiple="true"
                    :customRequest="e => upload(e, 17, '9pc')"
                    :accept="'.png,.jpg,.jpeg,.gif'"
                    :headers="uploadHeaders"
                  >
                    <div
                      v-if="
                        ['', null, undefined].includes(
                          popupSet17.langs.find(v => v.langCode == langCode)
                            .pcImgUrl
                        )
                      "
                    >
                      <div
                        class="w120 h120 tac"
                        style="color: #666666; font-size: 40px; line-height: 120px;"
                      >
                        <PictureOutlined />
                      </div>
                    </div>
                  </a-upload-dragger>
                  <div
                    v-if="
                      !['', null, undefined].includes(
                        popupSet17.langs.find(v => v.langCode == langCode)
                          .pcImgUrl
                      )
                    "
                    class="h120 pa l0 t0 sidebarContentBg"
                    :style="
                      `width: 120px; background: url('${
                        popupSet17?.langs?.find(v => v.langCode == langCode)
                          ?.pcImgUrl
                      }') center center/ cover no-repeat;`
                    "
                  >
                    <div class="hover">
                      <EyeOutlined
                        @click="
                          () =>
                            changeVisiblePic(
                              true,
                              popupSet17.langs.find(v => v.langCode == langCode)
                                .pcImgUrl
                            )
                        "
                      />
                      &nbsp;&nbsp;
                      <DeleteOutlined
                        @click="
                          popupSet17.langs.find(
                            v => v.langCode == langCode
                          ).pcImgUrl = null
                        "
                      />
                    </div>
                  </div>
                </div>
                <div class="tac">PC图片比例 420*560</div>
                <MaterialSelectionListModal
                  style="margin: 10px"
                  @submit="val => handleSubmit(val, 17, '9pc')"
                  :validateImageOrVideoArea="['420*560']"
                  :validateImageOrVideoFormatAndSizeByMB="{
                    jpg: 100,
                    png: 100,
                    gif: 100,
                    jpeg: 100,
                    'image/jpeg': 100,
                    'image/png': 100,
                    'image/gif': 100,
                    'image/jpg': 100
                  }"
                  :fileterResourceType="1"
                  :siteId="Number(queryParams?.siteId)"
                  :terminalId="Number(queryParams?.terminalId)"
                  :subTerminalId="Number(queryParams?.terminalId)"
                />
              </div>
              <div>
                <div class="w120 h120 mb10 pr">
                  <a-upload-dragger
                    :fileList="[]"
                    :show-upload-list="false"
                    name="file"
                    :multiple="true"
                    :customRequest="e => upload(e, 17, '9m')"
                    :accept="'.png,.jpg,.jpeg,.gif'"
                    :headers="uploadHeaders"
                  >
                    <div
                      v-if="
                        ['', null, undefined].includes(
                          popupSet17.langs.find(v => v.langCode == langCode)
                            .mImgUrl
                        )
                      "
                    >
                      <div
                        class="w120 h120 tac"
                        style="color: #666666; font-size: 40px; line-height: 120px;"
                      >
                        <PictureOutlined />
                      </div>
                    </div>
                  </a-upload-dragger>
                  <div
                    v-if="
                      !['', null, undefined].includes(
                        popupSet17.langs.find(v => v.langCode == langCode)
                          .mImgUrl
                      )
                    "
                    class="h120 pa l0 t0 sidebarContentBg"
                    :style="
                      `width: 120px; background: url('${
                        popupSet17?.langs?.find(v => v.langCode == langCode)
                          ?.mImgUrl
                      }') center center/ cover no-repeat;`
                    "
                  >
                    <div class="hover">
                      <EyeOutlined
                        @click="
                          () =>
                            changeVisiblePic(
                              true,
                              popupSet17.langs.find(v => v.langCode == langCode)
                                .mImgUrl
                            )
                        "
                      />
                      &nbsp;&nbsp;
                      <DeleteOutlined
                        @click="
                          popupSet17.langs.find(
                            v => v.langCode == langCode
                          ).mImgUrl = null
                        "
                      />
                    </div>
                  </div>
                </div>
                <div class="tac">M图片比例 311*160</div>
                <MaterialSelectionListModal
                  style="margin: 10px"
                  @submit="val => handleSubmit(val, 17, '9m')"
                  :validateImageOrVideoArea="['311*160']"
                  :validateImageOrVideoFormatAndSizeByMB="{
                    jpg: 100,
                    png: 100,
                    gif: 100,
                    jpeg: 100,
                    'image/jpeg': 100,
                    'image/png': 100,
                    'image/gif': 100,
                    'image/jpg': 100
                  }"
                  :fileterResourceType="1"
                  :siteId="Number(queryParams?.siteId)"
                  :terminalId="Number(queryParams?.terminalId)"
                  :subTerminalId="2"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="EditContainerRight">
          <div class="checkPicTabs mb20">
            <div
              :class="`checkPicTab ${checkPic === 1 ? 'check' : ''}`"
              @click="() => checkPicChange(1)"
            >
              PC端
            </div>
            <div
              :class="`checkPicTab ${checkPic === 2 ? 'check' : ''}`"
              @click="() => checkPicChange(2)"
            >
              M端
            </div>
          </div>
          <div
            class="pic checkPics"
            :style="
              `background: url(${
                checkPic === 1 ? pc1 : m1
              }) center top/contain no-repeat;`
            "
          ></div>
        </div>
      </div>
    </div>

    <div v-if="tabType === 10">
      <div style="margin-bottom: 10px" v-if="!popupParams.peopleSupport">
        <!-- 权益-email-不区分人群 -->
        <div style="margin-bottom: 10px">
          权益:
          <a-button
            type="primary"
            size="small"
            :disabled="
              getBenefitCouponCodeList(popupSet10).length >= 3 || notDefaultLang
            "
            @click="appendBenefitCoupon(popupSet10)"
            >新增</a-button
          >
        </div>
        <template
          v-for="(item, index) in getBenefitCouponCodeList(popupSet10)"
          :key="index"
        >
          <div style="display: flex;align-items: center;margin-bottom: 8px;">
            <a-input
              style="width: 220px;"
              v-model:value="item.couponDesc"
              placeholder="权益文案"
            ></a-input
            >&nbsp;:&nbsp;
            <a-input
              style="width: 120px"
              v-model:value="item.couponCode"
              placeholder="折扣码"
              :disabled="notDefaultLang"
              @change="
                e => {
                  handleCouponCodeChange(e, popupSet10, index)
                }
              "
            ></a-input>
            <MinusOutlined
              v-if="!notDefaultLang"
              :style="{
                fontSize: '16px',
                color: 'red',
                cursor: 'pointer',
                marginLeft: '10px'
              }"
              @click="() => removeBenefitCoupon(popupSet10, index)"
            />
          </div>
        </template>
      </div>
      <div
        style="margin-bottom: 10px"
        v-if="popupParams.peopleSupport === 1 && popupParams.peopleType === 1"
      >
        <!-- 权益-email-区分人群-新 -->
        <div style="margin-bottom: 10px">
          权益:
          <a-button
            type="primary"
            size="small"
            :disabled="
              getBenefitCouponCodeList(popupSet14).length >= 3 || notDefaultLang
            "
            @click="appendBenefitCoupon(popupSet14)"
            >新增</a-button
          >
        </div>
        <template
          v-for="(item, index) in getBenefitCouponCodeList(popupSet14)"
          :key="index"
        >
          <div style="display: flex;align-items: center;margin-bottom: 8px;">
            <a-input
              style="width: 220px;"
              v-model:value="item.couponDesc"
              placeholder="权益文案"
            ></a-input
            >&nbsp;:&nbsp;
            <a-input
              style="width: 120px"
              v-model:value="item.couponCode"
              placeholder="折扣码"
              :disabled="notDefaultLang"
              @change="
                e => {
                  handleCouponCodeChange(e, popupSet14, index)
                }
              "
            ></a-input>
            <MinusOutlined
              v-if="!notDefaultLang"
              :style="{
                fontSize: '16px',
                color: 'red',
                cursor: 'pointer',
                marginLeft: '10px'
              }"
              @click="() => removeBenefitCoupon(popupSet14, index)"
            />
          </div>
        </template>
      </div>
      <div
        style="margin-bottom: 10px"
        v-if="popupParams.peopleSupport === 1 && popupParams.peopleType === 0"
      >
        <!-- 权益-email-区分人群-老 -->
        <div style="margin-bottom: 10px">
          权益:
          <a-button
            type="primary"
            size="small"
            :disabled="
              getBenefitCouponCodeList(popupSet18).length >= 3 || notDefaultLang
            "
            @click="appendBenefitCoupon(popupSet18)"
            >新增</a-button
          >
        </div>
        <template
          v-for="(item, index) in getBenefitCouponCodeList(popupSet18)"
          :key="index"
        >
          <div style="display: flex;align-items: center;margin-bottom: 8px;">
            <a-input
              style="width: 220px;"
              v-model:value="item.couponDesc"
              placeholder="权益文案"
            ></a-input
            >&nbsp;:&nbsp;
            <a-input
              style="width: 120px"
              v-model:value="item.couponCode"
              placeholder="折扣码"
              :disabled="notDefaultLang"
              @change="
                e => {
                  handleCouponCodeChange(e, popupSet18, index)
                }
              "
            ></a-input>
            <MinusOutlined
              v-if="!notDefaultLang"
              :style="{
                fontSize: '16px',
                color: 'red',
                cursor: 'pointer',
                marginLeft: '10px'
              }"
              @click="() => removeBenefitCoupon(popupSet18, index)"
            />
          </div>
        </template>
      </div>
      <div class="df subscription" v-if="!popupParams.peopleSupport">
        <div>
          <div class="w500 mb20" v-if="queryParams?.terminalId === '1'">
            <div class="mb4">
              <span class="red">*</span>Email订阅成功文案-PC：
            </div>
            <quillEditor
              v-model:value="
                popupSet10.langs.find(v => v.langCode == langCode).pcText
              "
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              <span class="red">*</span>
              {{
                queryParams?.terminalId === '1'
                  ? 'Email订阅成功文案-M： '
                  : 'Email订阅成功文案-App： '
              }}
            </div>
            <quillEditor
              v-if="queryParams?.terminalId === '1'"
              v-model:value="
                popupSet10.langs.find(v => v.langCode == langCode).mText
              "
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
            <a-textarea
              v-else
              v-model:value="
                popupSet10.langs.find(v => v.langCode == langCode).mText
              "
            />
          </div>

          <div class="w500 mb20" v-if="queryParams?.terminalId === '2'">
            <div class="mb4">Email订阅副标题文案-App：</div>
            <a-textarea
              :maxlength="200"
              v-model:value="
                popupSet10.langs.find(v => v.langCode == langCode).mfText
              "
            />
          </div>

          <div class="w500 mb20">
            <div class="mb4"><span class="red">*</span>Email订阅成功按钮：</div>
            <a-input
              class="w300"
              v-model:value="
                popupSet10.langs.find(v => v.langCode == langCode).buttonText
              "
              placeholder="请输入（建议18个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              {{
                queryParams?.terminalId === '1'
                  ? 'Email订阅成功URL：'
                  : 'Email订阅成功路由：'
              }}
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet10.langs.find(v => v.langCode == langCode).subSuccessUrl
              "
            />
          </div>

          <div class="w500 mb20" v-if="queryParams?.terminalId === '1'">
            <div class="mb4">
              Email订阅成功主按钮文案：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet10.langs.find(v => v.langCode == langCode)
                  .primaryButtonText
              "
              :maxlength="20"
              placeholder="请输入（建议20个字符以内）"
            />
          </div>
          <div class="w500 mb20" v-if="queryParams?.terminalId === '1'">
            <div class="mb4">
              Email订阅成功主按钮跳转链接：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet10.langs.find(v => v.langCode == langCode)
                  .primaryButtonLink
              "
              placeholder="请输入"
            />
          </div>
          <div class="w500 mb20" v-if="queryParams?.terminalId === '1'">
            <div class="mb4">
              Email订阅成功次按钮文案：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet10.langs.find(v => v.langCode == langCode)
                  .secondaryButtonText
              "
              :maxlength="20"
              placeholder="请输入（建议20个字符以内）"
            />
          </div>
          <div class="w500 mb20" v-if="queryParams?.terminalId === '1'">
            <div class="mb4">
              Email订阅成功次按钮跳转链接：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet10.langs.find(v => v.langCode == langCode)
                  .secondaryButtonLink
              "
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="EditContainerRight" v-if="queryParams?.terminalId === '1'">
          <div class="checkPicTabs mb20">
            <div
              :class="`checkPicTab ${checkPic === 1 ? 'check' : ''}`"
              @click="() => checkPicChange(1)"
            >
              PC端
            </div>
            <div
              :class="`checkPicTab ${checkPic === 2 ? 'check' : ''}`"
              @click="() => checkPicChange(2)"
            >
              M端
            </div>
          </div>
          <div
            class="pic checkPics"
            :style="
              `background: url(${
                checkPic === 1 ? pc1 : m1
              }) center top/contain no-repeat;`
            "
          ></div>
        </div>
        <div class="EditContainerRight" v-else>
          <div class="checkPicTabs mb20">
            <div :class="`checkPicTab check`" @click="() => checkPicChange(2)">
              App端
            </div>
          </div>
          <div
            class="pic checkPics"
            :style="`background: url(${m1}) center top/contain no-repeat;`"
          ></div>
        </div>
      </div>

      <div
        class="df subscription"
        v-if="popupParams.peopleSupport === 1 && popupParams.peopleType === 1"
      >
        <div>
          <div class="w500 mb20">
            <div class="mb4">
              <span class="red">*</span>Email订阅成功文案-PC：
            </div>
            <quillEditor
              v-model:value="
                popupSet14.langs.find(v => v.langCode == langCode).pcText
              "
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              <span class="red">*</span>Email订阅成功文案-M：
            </div>
            <quillEditor
              v-model:value="
                popupSet14.langs.find(v => v.langCode == langCode).mText
              "
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
          </div>

          <div class="w500 mb20">
            <div class="mb4"><span class="red">*</span>Email订阅成功按钮：</div>
            <a-input
              class="w300"
              v-model:value="
                popupSet14.langs.find(v => v.langCode == langCode).buttonText
              "
              placeholder="请输入（建议18个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">Email订阅成功URL：</div>
            <a-input
              class="w300"
              v-model:value="
                popupSet14.langs.find(v => v.langCode == langCode).subSuccessUrl
              "
            />
          </div>

          <div class="w500 mb20">
            <div class="mb4">
              Email订阅成功主按钮文案：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet14.langs.find(v => v.langCode == langCode)
                  .primaryButtonText
              "
              :maxlength="20"
              placeholder="请输入（建议20个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              Email订阅成功主按钮跳转链接：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet14.langs.find(v => v.langCode == langCode)
                  .primaryButtonLink
              "
              placeholder="请输入"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              Email订阅成功次按钮文案：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet14.langs.find(v => v.langCode == langCode)
                  .secondaryButtonText
              "
              :maxlength="20"
              placeholder="请输入（建议20个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              Email订阅成功次按钮跳转链接：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet14.langs.find(v => v.langCode == langCode)
                  .secondaryButtonLink
              "
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="EditContainerRight">
          <div class="checkPicTabs mb20">
            <div
              :class="`checkPicTab ${checkPic === 1 ? 'check' : ''}`"
              @click="() => checkPicChange(1)"
            >
              PC端
            </div>
            <div
              :class="`checkPicTab ${checkPic === 2 ? 'check' : ''}`"
              @click="() => checkPicChange(2)"
            >
              M端
            </div>
          </div>
          <div
            class="pic checkPics"
            :style="
              `background: url(${
                checkPic === 1 ? pc1 : m1
              }) center top/contain no-repeat;`
            "
          ></div>
        </div>
      </div>

      <div
        class="df subscription"
        v-if="popupParams.peopleSupport === 1 && popupParams.peopleType === 0"
      >
        <div>
          <div class="w500 mb20">
            <div class="mb4">
              <span class="red">*</span>Email订阅成功文案-PC：
            </div>
            <quillEditor
              v-model:value="
                popupSet18.langs.find(v => v.langCode == langCode).pcText
              "
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              <span class="red">*</span>Email订阅成功文案-M：
            </div>
            <quillEditor
              v-model:value="
                popupSet18.langs.find(v => v.langCode == langCode).mText
              "
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
          </div>

          <div class="w500 mb20">
            <div class="mb4"><span class="red">*</span>Email订阅成功按钮：</div>
            <a-input
              class="w300"
              v-model:value="
                popupSet18.langs.find(v => v.langCode == langCode).buttonText
              "
              placeholder="请输入（建议18个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">Email订阅成功URL：</div>
            <a-input
              class="w300"
              v-model:value="
                popupSet18.langs.find(v => v.langCode == langCode).subSuccessUrl
              "
            />
          </div>

          <div class="w500 mb20">
            <div class="mb4">
              Email订阅成功主按钮文案：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet18.langs.find(v => v.langCode == langCode)
                  .primaryButtonText
              "
              :maxlength="20"
              placeholder="请输入（建议20个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              Email订阅成功主按钮跳转链接：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet18.langs.find(v => v.langCode == langCode)
                  .primaryButtonLink
              "
              placeholder="请输入"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              Email订阅成功次按钮文案：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet18.langs.find(v => v.langCode == langCode)
                  .secondaryButtonText
              "
              :maxlength="20"
              placeholder="请输入（建议20个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              Email订阅成功次按钮跳转链接：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet18.langs.find(v => v.langCode == langCode)
                  .secondaryButtonLink
              "
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="EditContainerRight">
          <div class="checkPicTabs mb20">
            <div
              :class="`checkPicTab ${checkPic === 1 ? 'check' : ''}`"
              @click="() => checkPicChange(1)"
            >
              PC端
            </div>
            <div
              :class="`checkPicTab ${checkPic === 2 ? 'check' : ''}`"
              @click="() => checkPicChange(2)"
            >
              M端
            </div>
          </div>
          <div
            class="pic checkPics"
            :style="
              `background: url(${
                checkPic === 1 ? pc1 : m1
              }) center top/contain no-repeat;`
            "
          ></div>
        </div>
      </div>
    </div>

    <div v-if="tabType === 11">
      <div style="margin-bottom: 10px" v-if="!popupParams.peopleSupport">
        <!-- 权益-phone-不区分人群 -->
        <div style="margin-bottom: 10px">
          权益:
          <a-button
            type="primary"
            size="small"
            :disabled="
              getBenefitCouponCodeList(popupSet11).length >= 3 || notDefaultLang
            "
            @click="appendBenefitCoupon(popupSet11)"
            >新增</a-button
          >
        </div>
        <template
          v-for="(item, index) in getBenefitCouponCodeList(popupSet11)"
          :key="index"
        >
          <div style="display: flex;align-items: center;margin-bottom: 8px;">
            <a-input
              style="width: 220px;"
              v-model:value="item.couponDesc"
              placeholder="权益文案"
            ></a-input
            >&nbsp;:&nbsp;
            <a-input
              style="width: 120px"
              v-model:value="item.couponCode"
              placeholder="折扣码"
              :disabled="notDefaultLang"
              @change="
                e => {
                  handleCouponCodeChange(e, popupSet11, index)
                }
              "
            ></a-input>
            <MinusOutlined
              v-if="!notDefaultLang"
              :style="{
                fontSize: '16px',
                color: 'red',
                cursor: 'pointer',
                marginLeft: '10px'
              }"
              @click="() => removeBenefitCoupon(popupSet11, index)"
            />
          </div>
        </template>
      </div>
      <div
        style="margin-bottom: 10px"
        v-if="popupParams.peopleSupport === 1 && popupParams.peopleType === 1"
      >
        <!-- 权益-phone-区分人群-新 -->
        <div style="margin-bottom: 10px">
          权益:
          <a-button
            type="primary"
            size="small"
            :disabled="
              getBenefitCouponCodeList(popupSet15).length >= 3 || notDefaultLang
            "
            @click="appendBenefitCoupon(popupSet15)"
            >新增</a-button
          >
        </div>
        <template
          v-for="(item, index) in getBenefitCouponCodeList(popupSet15)"
          :key="index"
        >
          <div style="display: flex;align-items: center;margin-bottom: 8px;">
            <a-input
              style="width: 220px;"
              v-model:value="item.couponDesc"
              placeholder="权益文案"
            ></a-input
            >&nbsp;:&nbsp;
            <a-input
              style="width: 120px"
              v-model:value="item.couponCode"
              placeholder="折扣码"
              :disabled="notDefaultLang"
              @change="
                e => {
                  handleCouponCodeChange(e, popupSet15, index)
                }
              "
            ></a-input>
            <MinusOutlined
              v-if="!notDefaultLang"
              :style="{
                fontSize: '16px',
                color: 'red',
                cursor: 'pointer',
                marginLeft: '10px'
              }"
              @click="() => removeBenefitCoupon(popupSet15, index)"
            />
          </div>
        </template>
      </div>
      <div
        style="margin-bottom: 10px"
        v-if="popupParams.peopleSupport === 1 && popupParams.peopleType === 0"
      >
        <!-- 权益-phone-区分人群-老 -->
        <div style="margin-bottom: 10px">
          权益:
          <a-button
            type="primary"
            size="small"
            :disabled="
              getBenefitCouponCodeList(popupSet19).length >= 3 || notDefaultLang
            "
            @click="appendBenefitCoupon(popupSet19)"
            >新增</a-button
          >
        </div>
        <template
          v-for="(item, index) in getBenefitCouponCodeList(popupSet19)"
          :key="index"
        >
          <div style="display: flex;align-items: center;margin-bottom: 8px;">
            <a-input
              style="width: 220px;"
              v-model:value="item.couponDesc"
              placeholder="权益文案"
            ></a-input
            >&nbsp;:&nbsp;
            <a-input
              style="width: 120px"
              v-model:value="item.couponCode"
              placeholder="折扣码"
              :disabled="notDefaultLang"
              @change="
                e => {
                  handleCouponCodeChange(e, popupSet19, index)
                }
              "
            ></a-input>
            <MinusOutlined
              v-if="!notDefaultLang"
              :style="{
                fontSize: '16px',
                color: 'red',
                cursor: 'pointer',
                marginLeft: '10px'
              }"
              @click="() => removeBenefitCoupon(popupSet19, index)"
            />
          </div>
        </template>
      </div>
      <div class="df subscription" v-if="!popupParams.peopleSupport">
        <div>
          <div class="w500 mb20" v-if="queryParams?.terminalId === '1'">
            <div class="mb4">
              <span class="red">*</span>Phone订阅成功文案-PC：
            </div>
            <quillEditor
              v-model:value="
                popupSet11.langs.find(v => v.langCode == langCode).pcText
              "
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              <span class="red">*</span>
              {{
                queryParams?.terminalId === '1'
                  ? 'Phone订阅成功文案-M： '
                  : 'Phone订阅成功文案-App： '
              }}
            </div>
            <quillEditor
              v-if="queryParams?.terminalId === '1'"
              v-model:value="
                popupSet11.langs.find(v => v.langCode == langCode).mText
              "
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
            <a-textarea
              v-else
              v-model:value="
                popupSet11.langs.find(v => v.langCode == langCode).mText
              "
            />
          </div>

          <div class="w500 mb20" v-if="queryParams?.terminalId === '2'">
            <div class="mb4">Phone订阅副标题文案-App：</div>
            <a-textarea
              :maxlength="200"
              v-model:value="
                popupSet11.langs.find(v => v.langCode == langCode).mfText
              "
            />
          </div>

          <div class="w500 mb20">
            <div class="mb4"><span class="red">*</span>Phone订阅成功按钮：</div>
            <a-input
              class="w300"
              v-model:value="
                popupSet11.langs.find(v => v.langCode == langCode).buttonText
              "
              placeholder="请输入（建议18个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              {{
                queryParams?.terminalId === '1'
                  ? 'Phone订阅成功URL：'
                  : 'Phone订阅成功路由：'
              }}
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet11.langs.find(v => v.langCode == langCode).subSuccessUrl
              "
              placeholder="请输入（建议18个字符以内）"
            />
          </div>
          <div class="w500 mb20" v-if="queryParams?.terminalId === '1'">
            <div class="mb4">
              Phone订阅成功主按钮文案：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet11.langs.find(v => v.langCode == langCode)
                  .primaryButtonText
              "
              :maxlength="20"
              placeholder="请输入（建议20个字符以内）"
            />
          </div>
          <div class="w500 mb20" v-if="queryParams?.terminalId === '1'">
            <div class="mb4">
              Phone订阅成功主按钮跳转链接：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet11.langs.find(v => v.langCode == langCode)
                  .primaryButtonLink
              "
              placeholder="请输入"
            />
          </div>
          <div class="w500 mb20" v-if="queryParams?.terminalId === '1'">
            <div class="mb4">
              Phone订阅成功次按钮文案：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet11.langs.find(v => v.langCode == langCode)
                  .secondaryButtonText
              "
              :maxlength="20"
              placeholder="请输入（建议20个字符以内）"
            />
          </div>
          <div class="w500 mb20" v-if="queryParams?.terminalId === '1'">
            <div class="mb4">
              Phone订阅成功次按钮跳转链接：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet11.langs.find(v => v.langCode == langCode)
                  .secondaryButtonLink
              "
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="EditContainerRight" v-if="queryParams?.terminalId === '1'">
          <div class="checkPicTabs mb20">
            <div
              :class="`checkPicTab ${checkPic === 1 ? 'check' : ''}`"
              @click="() => checkPicChange(1)"
            >
              PC端
            </div>
            <div
              :class="`checkPicTab ${checkPic === 2 ? 'check' : ''}`"
              @click="() => checkPicChange(2)"
            >
              M端
            </div>
          </div>
          <div
            class="pic checkPics"
            :style="
              `background: url(${
                checkPic === 1 ? pc1 : m1
              }) center top/contain no-repeat;`
            "
          ></div>
        </div>
        <div class="EditContainerRight" v-else>
          <div class="checkPicTabs mb20">
            <div :class="`checkPicTab check`" @click="() => checkPicChange(2)">
              App端
            </div>
          </div>
          <div
            class="pic checkPics"
            :style="`background: url(${m1}) center top/contain no-repeat;`"
          ></div>
        </div>
      </div>

      <div
        class="df subscription"
        v-if="popupParams.peopleSupport === 1 && popupParams.peopleType === 1"
      >
        <div>
          <div class="w500 mb20">
            <div class="mb4">
              <span class="red">*</span>Phone订阅成功文案-PC：
            </div>
            <quillEditor
              v-model:value="
                popupSet15.langs.find(v => v.langCode == langCode).pcText
              "
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              <span class="red">*</span>Phone订阅成功文案-M：
            </div>
            <quillEditor
              v-model:value="
                popupSet15.langs.find(v => v.langCode == langCode).mText
              "
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
          </div>

          <div class="w500 mb20">
            <div class="mb4"><span class="red">*</span>Phone订阅成功按钮：</div>
            <a-input
              class="w300"
              v-model:value="
                popupSet15.langs.find(v => v.langCode == langCode).buttonText
              "
              placeholder="请输入（建议18个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">Phone订阅成功URL：</div>
            <a-input
              class="w300"
              v-model:value="
                popupSet15.langs.find(v => v.langCode == langCode).subSuccessUrl
              "
              placeholder="请输入（建议18个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              Phone订阅成功主按钮文案：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet15.langs.find(v => v.langCode == langCode)
                  .primaryButtonText
              "
              :maxlength="20"
              placeholder="请输入（建议20个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              Phone订阅成功主按钮跳转链接：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet15.langs.find(v => v.langCode == langCode)
                  .primaryButtonLink
              "
              placeholder="请输入"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              Phone订阅成功次按钮文案：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet15.langs.find(v => v.langCode == langCode)
                  .secondaryButtonText
              "
              :maxlength="20"
              placeholder="请输入（建议20个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              Phone订阅成功次按钮跳转链接：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet15.langs.find(v => v.langCode == langCode)
                  .secondaryButtonLink
              "
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="EditContainerRight">
          <div class="checkPicTabs mb20">
            <div
              :class="`checkPicTab ${checkPic === 1 ? 'check' : ''}`"
              @click="() => checkPicChange(1)"
            >
              PC端
            </div>
            <div
              :class="`checkPicTab ${checkPic === 2 ? 'check' : ''}`"
              @click="() => checkPicChange(2)"
            >
              M端
            </div>
          </div>
          <div
            class="pic checkPics"
            :style="
              `background: url(${
                checkPic === 1 ? pc2 : m2
              }) center top/contain no-repeat;`
            "
          ></div>
        </div>
      </div>

      <div
        class="df subscription"
        v-if="popupParams.peopleSupport === 1 && popupParams.peopleType === 0"
      >
        <div>
          <div class="w500 mb20">
            <div class="mb4">
              <span class="red">*</span>Phone订阅成功文案-PC：
            </div>
            <quillEditor
              v-model:value="
                popupSet19.langs.find(v => v.langCode == langCode).pcText
              "
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              <span class="red">*</span>Phone订阅成功文案-M：
            </div>
            <quillEditor
              v-model:value="
                popupSet19.langs.find(v => v.langCode == langCode).mText
              "
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
          </div>

          <div class="w500 mb20">
            <div class="mb4"><span class="red">*</span>Phone订阅成功按钮：</div>
            <a-input
              class="w300"
              v-model:value="
                popupSet19.langs.find(v => v.langCode == langCode).buttonText
              "
              placeholder="请输入（建议18个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">Phone订阅成功URL：</div>
            <a-input
              class="w300"
              v-model:value="
                popupSet19.langs.find(v => v.langCode == langCode).subSuccessUrl
              "
              placeholder="请输入（建议18个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              Phone订阅成功主按钮文案：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet19.langs.find(v => v.langCode == langCode)
                  .primaryButtonText
              "
              :maxlength="20"
              placeholder="请输入（建议20个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              Phone订阅成功主按钮跳转链接：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet19.langs.find(v => v.langCode == langCode)
                  .primaryButtonLink
              "
              placeholder="请输入"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              Phone订阅成功次按钮文案：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet19.langs.find(v => v.langCode == langCode)
                  .secondaryButtonText
              "
              :maxlength="20"
              placeholder="请输入（建议20个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              Phone订阅成功次按钮跳转链接：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet19.langs.find(v => v.langCode == langCode)
                  .secondaryButtonLink
              "
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="EditContainerRight">
          <div class="checkPicTabs mb20">
            <div
              :class="`checkPicTab ${checkPic === 1 ? 'check' : ''}`"
              @click="() => checkPicChange(1)"
            >
              PC端
            </div>
            <div
              :class="`checkPicTab ${checkPic === 2 ? 'check' : ''}`"
              @click="() => checkPicChange(2)"
            >
              M端
            </div>
          </div>
          <div
            class="pic checkPics"
            :style="
              `background: url(${
                checkPic === 1 ? pc2 : m2
              }) center top/contain no-repeat;`
            "
          ></div>
        </div>
      </div>
    </div>

    <div v-if="tabType === 12">
      <div style="margin-bottom: 10px" v-if="!popupParams.peopleSupport">
        <!-- 权益-email+phone-不区分人群 -->
        <div style="margin-bottom: 10px">
          权益:
          <a-button
            type="primary"
            size="small"
            :disabled="
              getBenefitCouponCodeList(popupSet12).length >= 3 || notDefaultLang
            "
            @click="appendBenefitCoupon(popupSet12)"
            >新增</a-button
          >
        </div>
        <template
          v-for="(item, index) in getBenefitCouponCodeList(popupSet12)"
          :key="index"
        >
          <div style="display: flex;align-items: center;margin-bottom: 8px;">
            <a-input
              style="width: 220px;"
              v-model:value="item.couponDesc"
              placeholder="权益文案"
            ></a-input
            >&nbsp;:&nbsp;
            <a-input
              style="width: 120px"
              v-model:value="item.couponCode"
              placeholder="折扣码"
              :disabled="notDefaultLang"
              @change="
                e => {
                  handleCouponCodeChange(e, popupSet12, index)
                }
              "
            ></a-input>
            <MinusOutlined
              v-if="!notDefaultLang"
              :style="{
                fontSize: '16px',
                color: 'red',
                cursor: 'pointer',
                marginLeft: '10px'
              }"
              @click="() => removeBenefitCoupon(popupSet12, index)"
            />
          </div>
        </template>
      </div>
      <div
        style="margin-bottom: 10px"
        v-if="popupParams.peopleSupport === 1 && popupParams.peopleType === 1"
      >
        <!-- 权益-email+phone-区分人群-新 -->
        <div style="margin-bottom: 10px">
          权益:
          <a-button
            type="primary"
            size="small"
            :disabled="
              getBenefitCouponCodeList(popupSet16).length >= 3 || notDefaultLang
            "
            @click="appendBenefitCoupon(popupSet16)"
            >新增</a-button
          >
        </div>
        <template
          v-for="(item, index) in getBenefitCouponCodeList(popupSet16)"
          :key="index"
        >
          <div style="display: flex;align-items: center;margin-bottom: 8px;">
            <a-input
              style="width: 220px;"
              v-model:value="item.couponDesc"
              placeholder="权益文案"
            ></a-input
            >&nbsp;:&nbsp;
            <a-input
              style="width: 120px"
              v-model:value="item.couponCode"
              placeholder="折扣码"
              :disabled="notDefaultLang"
              @change="
                e => {
                  handleCouponCodeChange(e, popupSet16, index)
                }
              "
            ></a-input>
            <MinusOutlined
              v-if="!notDefaultLang"
              :style="{
                fontSize: '16px',
                color: 'red',
                cursor: 'pointer',
                marginLeft: '10px'
              }"
              @click="() => removeBenefitCoupon(popupSet16, index)"
            />
          </div>
        </template>
      </div>
      <div
        style="margin-bottom: 10px"
        v-if="popupParams.peopleSupport === 1 && popupParams.peopleType === 0"
      >
        <!-- 权益-email+phone-区分人群-老 -->
        <div style="margin-bottom: 10px">
          权益:
          <a-button
            type="primary"
            size="small"
            :disabled="
              getBenefitCouponCodeList(popupSet20).length >= 3 || notDefaultLang
            "
            @click="appendBenefitCoupon(popupSet20)"
            >新增</a-button
          >
        </div>
        <template
          v-for="(item, index) in getBenefitCouponCodeList(popupSet20)"
          :key="index"
        >
          <div style="display: flex;align-items: center;margin-bottom: 8px;">
            <a-input
              style="width: 220px;"
              v-model:value="item.couponDesc"
              placeholder="权益文案"
            ></a-input
            >&nbsp;:&nbsp;
            <a-input
              style="width: 120px"
              v-model:value="item.couponCode"
              placeholder="折扣码"
              :disabled="notDefaultLang"
              @change="
                e => {
                  handleCouponCodeChange(e, popupSet20, index)
                }
              "
            ></a-input>
            <MinusOutlined
              v-if="!notDefaultLang"
              :style="{
                fontSize: '16px',
                color: 'red',
                cursor: 'pointer',
                marginLeft: '10px'
              }"
              @click="() => removeBenefitCoupon(popupSet20, index)"
            />
          </div>
        </template>
      </div>
      <div class="df subscription" v-if="!popupParams.peopleSupport">
        <div>
          <div class="w500 mb20" v-if="queryParams?.terminalId === '1'">
            <div class="mb4">
              <span class="red">*</span>Email+Phone订阅成功文案-PC：
            </div>
            <quillEditor
              v-model:value="
                popupSet12.langs.find(v => v.langCode == langCode).pcText
              "
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              <span class="red">*</span>
              {{
                queryParams?.terminalId === '1'
                  ? 'Email+Phone订阅成功文案-M： '
                  : 'Email+Phone订阅成功文案-App： '
              }}
            </div>
            <quillEditor
              v-if="queryParams?.terminalId === '1'"
              v-model:value="
                popupSet12.langs.find(v => v.langCode == langCode).mText
              "
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
            <a-textarea
              v-else
              v-model:value="
                popupSet12.langs.find(v => v.langCode == langCode).mText
              "
            />
          </div>

          <div class="w500 mb20" v-if="queryParams?.terminalId === '2'">
            <div class="mb4">Email+Phone订阅副标题文案-App：</div>
            <a-textarea
              :maxlength="200"
              v-model:value="
                popupSet12.langs.find(v => v.langCode == langCode).mfText
              "
            />
          </div>

          <div class="w500 mb20">
            <div class="mb4">
              <span class="red">*</span>Email+Phone订阅成功按钮：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet12.langs.find(v => v.langCode == langCode).buttonText
              "
              placeholder="请输入（建议18个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              {{
                queryParams?.terminalId === '1'
                  ? 'Email+Phone订阅成功URL：'
                  : 'Email+Phone订阅成功路由：'
              }}
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet12.langs.find(v => v.langCode == langCode).subSuccessUrl
              "
              placeholder="请输入（建议18个字符以内）"
            />
          </div>
          <div class="w500 mb20" v-if="queryParams?.terminalId === '1'">
            <div class="mb4">
              Email+Phone订阅成功主按钮文案：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet12.langs.find(v => v.langCode == langCode)
                  .primaryButtonText
              "
              :maxlength="20"
              placeholder="请输入（建议20个字符以内）"
            />
          </div>
          <div class="w500 mb20" v-if="queryParams?.terminalId === '1'">
            <div class="mb4">
              Email+Phone订阅成功主按钮跳转链接：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet12.langs.find(v => v.langCode == langCode)
                  .primaryButtonLink
              "
              placeholder="请输入"
            />
          </div>
          <div class="w500 mb20" v-if="queryParams?.terminalId === '1'">
            <div class="mb4">
              Email+Phone订阅成功次按钮文案：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet12.langs.find(v => v.langCode == langCode)
                  .secondaryButtonText
              "
              :maxlength="20"
              placeholder="请输入（建议20个字符以内）"
            />
          </div>
          <div class="w500 mb20" v-if="queryParams?.terminalId === '1'">
            <div class="mb4">
              Email+Phone订阅成功次按钮跳转链接：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet12.langs.find(v => v.langCode == langCode)
                  .secondaryButtonLink
              "
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="EditContainerRight" v-if="queryParams?.terminalId === '1'">
          <div class="checkPicTabs mb20">
            <div
              :class="`checkPicTab ${checkPic === 1 ? 'check' : ''}`"
              @click="() => checkPicChange(1)"
            >
              PC端
            </div>
            <div
              :class="`checkPicTab ${checkPic === 2 ? 'check' : ''}`"
              @click="() => checkPicChange(2)"
            >
              M端
            </div>
          </div>
          <div
            class="pic checkPics"
            :style="
              `background: url(${
                checkPic === 1 ? pc1 : m1
              }) center top/contain no-repeat;`
            "
          ></div>
        </div>
        <div class="EditContainerRight" v-else>
          <div class="checkPicTabs mb20">
            <div :class="`checkPicTab check`" @click="() => checkPicChange(2)">
              App端
            </div>
          </div>
          <div
            class="pic checkPics"
            :style="`background: url(${m1}) center top/contain no-repeat;`"
          ></div>
        </div>
      </div>

      <div
        class="df subscription"
        v-if="popupParams.peopleSupport === 1 && popupParams.peopleType === 1"
      >
        <div>
          <div class="w500 mb20">
            <div class="mb4">
              <span class="red">*</span>Email+Phone订阅成功文案-PC：
            </div>
            <quillEditor
              v-model:value="
                popupSet16.langs.find(v => v.langCode == langCode).pcText
              "
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              <span class="red">*</span>Email+Phone订阅成功文案-M：
            </div>
            <quillEditor
              v-model:value="
                popupSet16.langs.find(v => v.langCode == langCode).mText
              "
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
          </div>

          <div class="w500 mb20">
            <div class="mb4">
              <span class="red">*</span>Email+Phone订阅成功按钮：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet16.langs.find(v => v.langCode == langCode).buttonText
              "
              placeholder="请输入（建议18个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">Email+Phone订阅成功URL：</div>
            <a-input
              class="w300"
              v-model:value="
                popupSet16.langs.find(v => v.langCode == langCode).subSuccessUrl
              "
              placeholder="请输入（建议18个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              Email+Phone订阅成功主按钮文案：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet16.langs.find(v => v.langCode == langCode)
                  .primaryButtonText
              "
              :maxlength="20"
              placeholder="请输入（建议20个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              Email+Phone订阅成功主按钮跳转链接：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet16.langs.find(v => v.langCode == langCode)
                  .primaryButtonLink
              "
              placeholder="请输入"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              Email+Phone订阅成功次按钮文案：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet16.langs.find(v => v.langCode == langCode)
                  .secondaryButtonText
              "
              :maxlength="20"
              placeholder="请输入（建议20个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              Email+Phone订阅成功次按钮跳转链接：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet16.langs.find(v => v.langCode == langCode)
                  .secondaryButtonLink
              "
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="EditContainerRight">
          <div class="checkPicTabs mb20">
            <div
              :class="`checkPicTab ${checkPic === 1 ? 'check' : ''}`"
              @click="() => checkPicChange(1)"
            >
              PC端
            </div>
            <div
              :class="`checkPicTab ${checkPic === 2 ? 'check' : ''}`"
              @click="() => checkPicChange(2)"
            >
              M端
            </div>
          </div>
          <div
            class="pic checkPics"
            :style="
              `background: url(${
                checkPic === 1 ? pc1 : m1
              }) center top/contain no-repeat;`
            "
          ></div>
        </div>
      </div>

      <div
        class="df subscription"
        v-if="popupParams.peopleSupport === 1 && popupParams.peopleType === 0"
      >
        <div>
          <div class="w500 mb20">
            <div class="mb4">
              <span class="red">*</span>Email+Phone订阅成功文案-PC：
            </div>
            <quillEditor
              v-model:value="
                popupSet20.langs.find(v => v.langCode == langCode).pcText
              "
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              <span class="red">*</span>Email+Phone订阅成功文案-M：
            </div>
            <quillEditor
              v-model:value="
                popupSet20.langs.find(v => v.langCode == langCode).mText
              "
              style="height: 100px; width: 500px;"
              :options="editorOption"
            />
          </div>

          <div class="w500 mb20">
            <div class="mb4">
              <span class="red">*</span>Email+Phone订阅成功按钮：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet20.langs.find(v => v.langCode == langCode).buttonText
              "
              placeholder="请输入（建议18个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">Email+Phone订阅成功URL：</div>
            <a-input
              class="w300"
              v-model:value="
                popupSet20.langs.find(v => v.langCode == langCode).subSuccessUrl
              "
              placeholder="请输入（建议18个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              Email+Phone订阅成功主按钮文案：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet20.langs.find(v => v.langCode == langCode)
                  .primaryButtonText
              "
              :maxlength="20"
              placeholder="请输入（建议20个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              Email+Phone订阅成功主按钮跳转链接：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet20.langs.find(v => v.langCode == langCode)
                  .primaryButtonLink
              "
              placeholder="请输入"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              Email+Phone订阅成功次按钮文案：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet20.langs.find(v => v.langCode == langCode)
                  .secondaryButtonText
              "
              :maxlength="20"
              placeholder="请输入（建议20个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              Email+Phone订阅成功次按钮跳转链接：
            </div>
            <a-input
              class="w300"
              v-model:value="
                popupSet20.langs.find(v => v.langCode == langCode)
                  .secondaryButtonLink
              "
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="EditContainerRight">
          <div class="checkPicTabs mb20">
            <div
              :class="`checkPicTab ${checkPic === 1 ? 'check' : ''}`"
              @click="() => checkPicChange(1)"
            >
              PC端
            </div>
            <div
              :class="`checkPicTab ${checkPic === 2 ? 'check' : ''}`"
              @click="() => checkPicChange(2)"
            >
              M端
            </div>
          </div>
          <div
            class="pic checkPics"
            :style="
              `background: url(${
                checkPic === 1 ? pc1 : m1
              }) center top/contain no-repeat;`
            "
          ></div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { quillEditor } from 'vue3-quill'
import { toRefs, inject, reactive, watch, ref, nextTick, computed } from 'vue'
import {
  EyeOutlined,
  PictureOutlined,
  DeleteOutlined,
  MinusOutlined
} from '@ant-design/icons-vue'
import smsStyle2 from './smsStyle2.vue'
import emailPcImage from '@/assets/img/email-pc.png'
import phonePcImage from '@/assets/img/sms-pc.png'
import emailMImage from '@/assets/img/email-m.png'
import phoneMImage from '@/assets/img/sms-m.png'

export default {
  components: {
    quillEditor,
    DeleteOutlined,
    EyeOutlined,
    PictureOutlined,
    MinusOutlined,
    smsStyle2
  },
  props: {
    notDefaultLang: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const initState = inject('initState')
    const smsStyle2Ref = ref()

    const imageMap = {
      // tabType 20 对应的图片
      20: {
        1: emailPcImage, // 当 checkPic === 1
        other: emailMImage // 当 checkPic !== 1
      },
      // tabType 21 对应的图片
      21: {
        1: phonePcImage, // 当 checkPic === 1
        other: phoneMImage // 当 checkPic !== 1
      }
    }

    const picTabs = computed(() => {
      if (initState.queryParams?.terminalId === '1') {
        return [
          { label: 'PC端', value: 1 },
          { label: 'M端', value: 2 }
        ]
      }
      return [{ label: 'App端', value: 2 }]
    })
    const currentPic = computed(() => {
      // 获取当前 tabType 对应的图片配置
      const tabTypeConfig = imageMap[initState.tabType]

      // 如果没有找到对应的 tabType 配置，可以返回一个默认图片或 null
      if (!tabTypeConfig) {
        console.warn(`未知 tabType: ${initState.tabType}`)
        // 返回一个默认图片或者 null，根据你的需求决定
        return null // 或者例如 defaultPlaceholderImage
      }

      // 根据 checkPic 的值返回对应的图片
      return initState.checkPic === 1 &&
        initState.queryParams?.terminalId === '1'
        ? tabTypeConfig[1]
        : tabTypeConfig.other
    })

    // Provide a method to trigger validation from parent
    const validateSmsStyle2 = () => {
      if (smsStyle2Ref.value && smsStyle2Ref.value.validate) {
        return smsStyle2Ref.value.validate()
      }
      return Promise.resolve(true)
    }

    const state = reactive({
      ...props,
      checkPicChange: (checkPic = 1) => {
        state.checkPic = checkPic
      },
      checkPic: 1,
      getCurrentLangConfig: list => {
        const langs = list?.langs || []
        const currentLang = langs.find(
          lang => lang.langCode === initState.langCode
        )
        return currentLang || null
      },
      getBenefitCouponCodeList: list => {
        const currentLang = state.getCurrentLangConfig(list)
        return currentLang?.benefitCouponCodeList || []
      },
      appendBenefitCoupon: list => {
        ;(list?.langs || []).forEach(lang => {
          if (!Array.isArray(lang.benefitCouponCodeList)) {
            lang.benefitCouponCodeList = []
          }
          lang.benefitCouponCodeList.push({})
        })
      },
      removeBenefitCoupon: (list, index) => {
        ;(list?.langs || []).forEach(lang => {
          if (!Array.isArray(lang.benefitCouponCodeList)) {
            lang.benefitCouponCodeList = []
          }
          lang.benefitCouponCodeList.splice(index, 1)
        })
      },
      handleCouponCodeChange: (e, list, index) => {
        list.langs.forEach(lang => {
          if (!Array.isArray(lang.benefitCouponCodeList)) {
            lang.benefitCouponCodeList = []
          }
          lang.benefitCouponCodeList.forEach((coupon, idx) => {
            if (idx === index) {
              coupon.couponCode = e.target.value
            }
          })
        })
      },
      changeQuickRegisterCheckStatus: () => {
        // popupSet.langs.forEach(lang => {
        //   lang.quickRegisterCheckStatus = val.target.value
        // })
      }
    })
    watch(
      () => initState.styleType,
      val => {
        if (+val === 2) {
          initState.tabType = 20
        } else {
          initState.tabType = 9
        }
        nextTick(() => {
          const el = document.querySelector(`[data-type="9"]`)
          if (!el) return

          el.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          })
        })
      }
    )
    return {
      handleCouponCodeChange: state.handleCouponCodeChange,
      getCurrentLangConfig: state.getCurrentLangConfig,
      getBenefitCouponCodeList: state.getBenefitCouponCodeList,
      appendBenefitCoupon: state.appendBenefitCoupon,
      removeBenefitCoupon: state.removeBenefitCoupon,
      changeQuickRegisterCheckStatus: state.changeQuickRegisterCheckStatus,
      checkboxOptions: [
        {
          label: '默认勾选',
          value: 1
        },
        {
          label: '默认不勾选',
          value: 0
        }
      ],
      pc1:
        'https://cdn-image.kapeixi.cn/web/8fa83ad5-c204-4363-8d8e-acaf1d9ea721/sms-01.png',
      m1:
        'https://cdn-image.kapeixi.cn/web/0e61b62c-3bd2-4430-9d35-80de4ab94592/sms-02.png',
      pc2:
        'https://cdn-image.kapeixi.cn/web/88d7d1e7-545b-4f77-ac85-04e8270448d9/sms-03.png',
      m2:
        'https://cdn-image.kapeixi.cn/web/7cab2284-fc58-4b6f-8906-83d60a2b9ef1/sms-04.png',
      ...toRefs(initState),
      smsStyle2Ref,
      picTabs,
      currentPic,
      validateSmsStyle2,
      PrivacyOptions: {
        placeholder: '请输入',
        modules: {
          toolbar: [
            [
              {
                font: ['Muli-Light', 'Note-Regular']
              }
            ],
            [
              {
                size: ['8px']
              }
            ],
            ['bold', 'link'],
            [
              {
                color: [
                  'red',
                  'blue',
                  'green',
                  'black',
                  'yellow',
                  'pink',
                  'white',
                  '#14AA6E',
                  '#999999'
                ]
              }
            ]
          ]
        }
      },
      editorOption: {
        placeholder: '请输入',
        modules: {
          toolbar: [
            [
              {
                font: ['Muli-Light', 'Note-Regular']
              }
            ],
            [
              {
                size: [
                  '12px',
                  '14px',
                  '16px',
                  '18px',
                  '20px',
                  '22px',
                  '24px',
                  '26px',
                  '28px',
                  '30px',
                  '32px',
                  '34px',
                  '36px',
                  '38px',
                  '40px'
                ]
              }
            ],
            ['bold', 'link'],
            [
              {
                color: [
                  'red',
                  'blue',
                  'green',
                  'black',
                  'yellow',
                  'pink',
                  'white',
                  '#14AA6E',
                  '#999999'
                ]
              }
            ]
          ]
        }
      }
    }
  }
}
</script>
<style scoped>
.checkPicTabs {
  width: 146px;
  height: 36px;
  background: #f0f0f0;
  display: flex;
  padding: 3px;
  border-radius: 3px;
  margin: 0 auto 20px auto;
}

.checkPicTab {
  width: 70px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 3px;
  cursor: pointer;
}

.checkPicTab.check {
  background: #ffffff;
}

.EditContainerRight {
  background: #f4f4f4;
  width: 400px;
  padding: 14px;
  margin: 14px;
}

.checkPics {
  height: 560px;
}

.sidebarContentBg .hover {
  width: 120px;
  height: 120px;
  display: none;
  cursor: pointer;
  color: #ffffff;
  text-align: center;
  line-height: 120px;
  background: rgba(0, 0, 0, 0.3);
}

.sidebarContentBg:hover .hover {
  display: block;
}
</style>
<style>
.subscription .ant-upload.ant-upload-drag .ant-upload {
  padding: 0;
}
.smsStyle2 {
  display: flex;
  gap: 10px;
}
</style>
